import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  Table,
  Tooltip,
  Button,
  Modal,
  message,
  Drawer,
  Input,
} from "antd";
import PresetTest from "../../components/PresetTest";
import { SendOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import apiClient from "services/apiClient";

import Flex from "components/shared-components/Flex";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useMyContext } from "Context/MyContextProvider";
import ListItemPreview from "./ListItemPreview";
import CustomDrawer from "components/shared-components/CustomDrawer";
const { confirm } = Modal;

export const GetPresets = async (
  setLoading,
  api,
  UserData,
  authToken,
  setpresets
) => {
  setLoading(true);
  try {
    const response = await apiClient.get(
      `${api}list-message-preset/${UserData?.id}`,
      {
        headers: {
          Authorization: "Bearer " + authToken,
        },
      }
    );
    if (response.data.status) {
      setpresets(response.data?.data);
    }
  } catch (error) {
  } finally {
    setLoading(false);
  }
};
const ListMessagePresets = () => {
  const { Permisson, authToken, api, UserData } =
    useMyContext();
  const [loading, setLoading] = useState(false);
  const [presets, setpresets] = useState([]);

  useEffect(() => {
    GetPresets(setLoading, api, UserData, authToken, setpresets);
  }, []);

  const tableColumns = [
    {
      title: "Preset Name",
      dataIndex: "name",
      sorter: {
        compare: (a, b) => a.name.length - b.name.length,
      },
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_, item) => {
        const actions = [
          {
            key: "edit",
            show: true,
            tooltip: "Edit",
            content: (
              <Link
                to={{ pathname: "edit" }}
                state={{
                  presetData: item,
                  editState: true,
                }}
                className="mr-2"
              >
                <Button className="mr-2" icon={<EditOutlined />} size="small" />
              </Link>
            ),
          },
          {
            key: "quickSend",
            show: true,
            tooltip: "Quick Send",
            content: (
              <Button
                type="primary"
                className="mr-2"
                icon={<SendOutlined />}
                onClick={() => HandleQuickSend(item?.id)}
                size="small"
              />
            ),
          },
          {
            key: "preview",
            show: true,
            tooltip: "Message Preview",
            content: (
              <Button
                color="primary"
                className="mr-2"
                variant="filled"
                icon={<EyeOutlined className="h4" />}
                onClick={() => HandlePreview(item)}
              />
            ),
          },
          {
            key: "delete",
            show: Permisson?.includes("Delete Carousel Preset"),
            tooltip: "Delete",
            content: (
              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => showConfirm(item.id, item?.name)}
                size="small"
              />
            ),
          },
        ];

        return (
          <div className="text-right d-flex">
            {actions
              .filter((a) => a.show)
              .map((a) => (
                <Tooltip title={a.tooltip} key={`${a.key}-${item.id}`}>
                  {a.content}
                </Tooltip>
              ))}
          </div>
        );
      },
    },
  ];

  function showConfirm(id, name) {
    confirm({
      title: "Do you want to delete this preset?",
      content:
        "By deleting the preset, it will be permanently removed from Meta and can't be restored.",
      onOk() {
        HandleDelete(id, name);
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  }

  const HandleDelete = async (id) => {
    try {
      setLoading(true);
      const response = await apiClient.delete(
        `${api}list-message-preset/${id}`,
        {
          headers: {
            Authorization: "Bearer " + authToken,
          },
        }
      );
      if (response.data.status) {
        GetPresets(setLoading, api, UserData, authToken, setpresets);
        message.success(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        message.error(error.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  //drawer states
  const [open, setOpen] = useState(false);
  const [selectedPresetId, setSelectedPresetId] = useState(null);

  const HandleQuickSend = (id) => {
    setSelectedPresetId(id);
    setIsModalVisible(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  //preview start from here
  const [previewData, setPreviewData] = useState();
  const HandlePreview = (data) => {
    setPreviewData(data);
    setOpen(true);
  };



  // Add state for search
  const [searchText, setSearchText] = useState("");

  // Add filtered data
  const filteredPresets = useMemo(() => {
    if (!searchText) return presets;

    const searchLower = searchText.toLowerCase();
    return presets.filter((preset) =>
      preset.name?.toLowerCase().includes(searchLower)
    );
  }, [presets, searchText]);
  return (
    <>
      <PresetTest
        open={isModalVisible}
        onClose={() => {
          setIsModalVisible(false);
          setSelectedPresetId(null);
        }}
        presetId={selectedPresetId}
        presetType="list"
      />
      <Card bodyStyle={{ padding: "0px" }}>
        <div className="container-fluid">
          <Flex
            justifyContent="space-between"
            alignItems="center"
            className="py-4"
          >
            <h2>List Item Presets</h2>
            <div className="d-flex">
              <Input.Search
                placeholder="Search by name, header, body, footer, or button text..."
                allowClear
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ maxWidth: 400 }}
              />
              {Permisson?.includes("Create Template") && (
                <div>
                  <Link to="add">
                    <Button type="primary" className="ml-2">
                      <PlusOutlined />
                      <span>New</span>
                    </Button>
                  </Link>
                </div>
              )}
            </div>
          </Flex>
        </div>

        <div className="table-responsive">
          <Table
            loading={loading}
            columns={tableColumns}
            dataSource={filteredPresets}
            rowKey="id"
          />
        </div>
      </Card>

      <CustomDrawer
        closable={false}
        onClose={onClose}
        open={open}
      >
        <ListItemPreview
          headerType={"text"}
          open={open}
          header={previewData?.header}
          body={previewData?.body}
          footer={previewData?.footer}
          media={previewData?.null}
          rows={previewData?.rows ? JSON.parse(previewData.rows) : []}
          buttonText={previewData?.button_text}
        />
      </CustomDrawer>
    </>
  );
};

export default ListMessagePresets;
